import { createContext, useContext } from "react";
import type { ShiftTemplate } from "@/entities/shift-template/model/types";

export interface CreateShiftDefaults {
  date?: Date | null;
  template?: ShiftTemplate;
  clientId?: number;
  siteId?: number;
  guardId?: number;
  categoryId?: number;
  shiftType?: string;
  endDate?: string;
  startTime?: string;
  endTime?: string;
  numberOfGuards?: number;
}

export interface CreateShiftPrefill extends CreateShiftDefaults {
  onSuccess?: () => void;
}

export interface CreateShiftContextValue {
  openCreateShift: (prefill?: CreateShiftPrefill) => void;
}

export const CreateShiftContext = createContext<CreateShiftContextValue | null>(null);

export function useCreateShiftModal() {
  const context = useContext(CreateShiftContext);
  if (!context) {
    throw new Error("useCreateShiftModal must be used within a CreateShiftProvider");
  }
  return context;
}
